(function () {
  const cache = {};

  async function fetchBucket(tag) {
    if (cache[tag]) return cache[tag];
    try {
      const res = await fetch(
        `/products.json?tag=${encodeURIComponent(tag)}&limit=250`
      );
      const { products } = await res.json();

      // Strict filter — only products that actually have this exact bucket tag
      const filtered = products.filter(
        (p) =>
          p.tags &&
          p.tags.some(
            (t) => t.trim().toLowerCase() === tag.toLowerCase()
          )
      );

      cache[tag] = filtered;
      return filtered;
    } catch (e) {
      console.warn('Swatch fetch failed:', e);
      return [];
    }
  }

function buildSwatches(products, currentHandle) {
  const filtered = products.filter(p => p.images && p.images.length > 0);

  filtered.sort((a, b) => {
    if (a.handle === currentHandle) return -1;
    if (b.handle === currentHandle) return 1;
    return 0;
  });

  return filtered.map(p => {
    const imgSrc = p.images[0].src;
    const isCurrent = p.handle === currentHandle;

    if (isCurrent) {
      return `<span class="bucket-swatch bucket-swatch--active" title="${p.title}">
        <img src="${imgSrc}" alt="${p.title}">
      </span>`;
    } else {
      return `<a href="/products/${p.handle}"
                 class="bucket-swatch"
                 title="${p.title}"
                 aria-label="${p.title}">
        <img src="${imgSrc}" alt="${p.title}">
      </a>`;
    }
  }).join('');
}

  async function renderSwatchGroup(el) {
    // Skip if already rendered
    if (el.dataset.swatchRendered === 'true') return;
    el.dataset.swatchRendered = 'true';

    const tag = el.dataset.bucket;
    const currentHandle = el.dataset.handle;

    const products = await fetchBucket(tag);
    const html = buildSwatches(products, currentHandle);
    el.innerHTML = html || '';
  }

  function observeSwatches() {
    const groups = document.querySelectorAll(
      '.bucket-swatch-group:not([data-swatch-rendered])'
    );
    if (!groups.length) return;

    // Use IntersectionObserver to render only when near viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            renderSwatchGroup(entry.target);
            observer.unobserve(entry.target); // stop watching once rendered
          }
        });
      },
      {
        rootMargin: '200px 0px', // start fetching 200px before entering viewport
      }
    );

    groups.forEach((el) => observer.observe(el));
  }

  // Expose globally so collections.liquid AJAX can re-init after grid reload
  window.initBucketSwatches = function () {
    observeSwatches();
  };

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initBucketSwatches);
  } else {
    window.initBucketSwatches();
  }
})();